import * as React from 'react';
import DeviceList from "../../components/deviceList/deviceList";
import deviceManagementService from "../../client-api/services/deviceManagement";

const DeviceManagement = () => {
  const devices =  deviceManagementService.GetDevices();


  return (
    <div>
      <DeviceList devices={devices}/>
    </div>
)
}

export default DeviceManagement